import axios from 'axios'
import { getApiError } from '@/composables/getApiError'
import { BASE_URL } from '@/environment/environment'
import { getBlobErrorMessage } from '@/modules/documents-new/utils/fileHelpers'
import { useFeedbackStore } from '@/modules/feedback/stores/feedbackStore'

/** Скачивает печатную карточку объекта с ручки `document/`. */
export async function downloadDocument(
  path: string,
  format: 'pdf' | 'docx',
  fallbackName: string,
): Promise<void> {
  const feedbackStore = useFeedbackStore()
  const base = String(BASE_URL || '').replace(/\/$/, '')
  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  try {
    const response = await axios.get<Blob>(`${base}${normalizedPath}`, {
      params: { file_format: format },
      responseType: 'blob',
    })

    const disposition = String(response.headers['content-disposition'] || '')
    const filename = disposition.match(/filename="?([^";]+)"?/)?.[1]
      || `${fallbackName}.${format}`
    const url = URL.createObjectURL(response.data)
    const link = document.createElement('a')

    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(url)
  }
  catch (error) {
    let message = getApiError(error, 'Не удалось сформировать отчёт')
    if (axios.isAxiosError(error) && error.response?.data instanceof Blob) {
      message = (await getBlobErrorMessage(error.response.data)) || message
    }

    feedbackStore.showToast({
      type: 'error',
      message,
    })
  }
}
